export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref14316.d446e214.jpg";